import { ClickAwayListener, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Icons, Tooltip, Typography } from '@nutrien/cxp-components';
import React, { useState } from 'react';

interface Props {
  comment: string;
  attentionFlag: boolean;
}

const useStyles = makeStyles({
  messageIcon: {
    verticalAlign: 'text-bottom',
    marginLeft: 16,
  },
  inline: {
    display: 'inline',
  },
  inlineBlock: {
    display: 'inline-block',
  },
  tooltipTextColor: {
    color: 'rgba(255, 255, 255, 0.87)',
  },
});

const CommentToolTip: React.FC<Props> = ({ comment, attentionFlag }) => {
  const classes = useStyles();
  const [open, setOpen] = useState<boolean>(false);

  const handleTooltipClose = (e: { stopPropagation: () => void }) => {
    setOpen(false);
    e.stopPropagation();
  };

  const handleTooltipOpen = (e: { stopPropagation: () => void }) => {
    setOpen(true);
    e.stopPropagation();
  };

  return (
    <>
      {comment?.length ? (
        <ClickAwayListener onClickAway={e => (open ? handleTooltipClose(e) : '')}>
          <Grid className={classes.inline}>
            <Tooltip
              PopperProps={{
                disablePortal: true,
              }}
              onClose={e => (open ? handleTooltipClose(e) : '')}
              open={open}
              disableFocusListener
              disableHoverListener
              disableTouchListener
              title={<Typography className={classes.tooltipTextColor}>{comment}</Typography>}
              className={classes.inlineBlock}
              placement="right"
              arrow
            >
              <Typography
                data-testid="toogle-tooltip"
                onMouseDown={e => e.stopPropagation()}
                onMouseUp={e => {
                  if (open) handleTooltipClose(e);
                  else handleTooltipOpen(e);
                }}
                onTouchStart={e => e.stopPropagation()}
                onTouchEnd={e => {
                  if (open) handleTooltipClose(e);
                  else handleTooltipOpen(e);
                  e.preventDefault();
                }}
              >
                <Icons.MessageSquareFeather
                  color={attentionFlag ? 'error' : 'primary'}
                  className={classes.messageIcon}
                />
              </Typography>
            </Tooltip>
          </Grid>
        </ClickAwayListener>
      ) : (
        ''
      )}
    </>
  );
};

export default CommentToolTip;
